/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Akceptuj i kontynuuj',
    APPROVE: 'Zatwierdzić',
    CANCEL: 'Anuluj',
    SAVE: 'Zapisz'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'Zapoznałem/-am się z Regulaminem i go akceptuję',
    ACCEPT_TERMS_DESCRIPTION:
      'Przed uzyskaniem dostępu do platformy Prozis Partnership, zapoznaj się i zaakceptuj Regulamin Programu Influencer Prozis.',
    ACCEPT_TERMS_NAV_TITLE: 'Regulamin',
    ACCEPT_TERMS_SCROLL_HINT: 'Przeczytaj do końca, aby kontynuować.',
    DASHBOARD: 'Pulpit nawigacyjny',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Zauważyliśmy, że powiadomienia nie są aktywne. Aby kontynuować korzystanie z aplikacji, musisz aktywować powiadomienia.',
    ENABLE_NOTIFICATIONS_LINK: 'Powiadomienia można aktywować tutaj',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Powiadomienia',
    ENABLE_NOTIFICATIONS_TITLE: 'Aktywuj powiadomienia, aby kontynuować',
    HOME: 'Strona główna',
    INSTALL_PROZIS_APP: 'Zainstaluj aplikację Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Zainstaluj naszą aplikację mobilną, aby uzyskać dostęp do wszystkich funkcji.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Zainstaluj aplikację',
    LOGOUT: 'Wyjście',
    NOT_FOUND: 'Nie znaleziono',
    OR: 'Lub',
    OR_SCAN_QR_CODE: 'Lub zeskanuj kod QR',
    SCAN_QR_CODE: 'Zeskanuj kod QR za pomocą urządzenia mobilnego',
    TODOS: 'Wszystkie',
    UNAUTHORIZED_DESCRIPTION_1:
      'Sprawdź u swojego przełożonego uprawnienia dostępu.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Po weryfikacji spróbuj zalogować się ponownie.',
    UNAUTHORIZED_NAV_TITLE: 'Odmowa dostępu',
    UNAUTHORIZED_TITLE: 'Brak dostępu'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
